export default __webpack_public_path__ + "static/careers-slide-5-c0a5f7060acbffb1c775b04fb33896ef.png";